import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Box, Divider, dividerClasses, Typography } from "@mui/material";
import CustomCard from "../../../components/@extended/CustomCard";
import { useParams } from "react-router-dom";
import { getSiteBudgetAndExpenditure } from "./siteDashboardUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  indexAxis: "y",
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
  },
  options: {
    scales: {
      x: {
        ticks: {
          beginAtZero: true,
          max: 1000,
          min: 0,
        },
      },
      y: {
        ticks: {
          beginAtZero: false,
          max: 8,
          min: -3,
        },
      },
    },
  },
};
const FinanceSiteExpenditureChart = ({dashboardData}) => {
  const { trialSiteId } = useParams();

  const { totalBudget, totalExpenditure } = useMemo(
    () => getSiteBudgetAndExpenditure(dashboardData, trialSiteId),
    [dashboardData, trialSiteId]
  );


    const data = useMemo(() => {
        return {
          chartData: {
            labels: [""],
            datasets: [
              {
                label: "Total Budget",
                data: [totalBudget],
                borderColor: "#FF4000",
                backgroundColor: "#FF4000",
              },
              {
                label: "Current Expenditure",
                data: [totalExpenditure],
                borderColor: '#602EB5',
                backgroundColor: '#602EB5',
              },
            ],
          },
        };
      });
  return (
    <CustomCard
    title={"Site Current Expenditure"}
    subHeader={"(all costs are in USD)"}
  >
    <Bar options={options} data={data.chartData} />
    <Box
          sx={{
            display: 'flex',
            columnGap: 2,
            justifyContent: 'center',
            // flexDirection: 'column',
            pt: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              pt: 2,
            }}
          >
            <Typography variant="subtitle1" color="initial">
              Total Budget
            </Typography>
            <Typography variant="h5" color="initial">
              ${totalBudget}
            </Typography>
          </Box>
          <Box
            sx={{
              height: '100%',
              [`& .${dividerClasses.root}`]: {
                mx: 0.5,
              },
            }}
          >
            <Divider orientation="vertical" flexItem />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              pt: 2,
            }}
          >
            <Typography variant="subtitle1" color="initial">
              Total Expenditure
            </Typography>
            <Typography variant="h5" color="initial">
              ${totalExpenditure}
            </Typography>
          </Box>
        </Box>
  </CustomCard>
  )
}

export default FinanceSiteExpenditureChart